import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DEMORA_EN_VOLCADORAS } from '../../../../config/tables'
import CargarDemoraEnVolcadora from './CargarDemoraEnVolcadora'

function DemoraEnVolcadorasView () {
  return (
    <>
      <CargarDemoraEnVolcadora />
      <MuiTable id={TABLA_DEMORA_EN_VOLCADORAS} />
    </>
  )
}

export default DemoraEnVolcadorasView
